const assertEx = (expr, message) => {
    if (expr)
        return expr;
    throw Error(message);
};
export default assertEx;
